import { FiltersItem } from './FiltersItem';
import { DatePickerWrapper } from '../DatePickerWrapper/DatePickerWrapper';

interface IProps {
  label: string;
  fromValue: Date | null | undefined;
  toValue: Date | null | undefined;
  onFromChange: (...event: any[]) => void;
  onToChange: (...event: any[]) => void;
  onClear: () => void;
  maxDate?: Date | null;
}

export const DateFilter = ({ label, fromValue, toValue, onFromChange, onToChange, onClear, maxDate }: IProps) => (
  <FiltersItem label={label} onClear={onClear} appliedFiltersCount={[fromValue, toValue].filter((x) => x).length}>
    <DatePickerWrapper
      label="From"
      maxDate={maxDate}
      name={`${label} ${fromValue}`}
      onChange={onFromChange}
      value={fromValue}
    />
    <DatePickerWrapper label="To" maxDate={maxDate} name={`${label} ${toValue}`} onChange={onToChange} value={toValue} />
  </FiltersItem>
);
